function setDoInterval(func, t) {
  func();
  return setInterval(func, t);
}

export { setDoInterval };
